import { useInstallerPush } from '../../hooks/useInstallerPush';

// "Enable notifications" control for the installer PWA: opt into Web Push so job
// offers reach the installer even when the app is closed. Renders nothing where
// push is unsupported; shows an install hint on iOS Safari.
export default function InstallerPushToggle({ token }) {
  const { supported, subscribed, busy, error, iosBlocked, permission, enable, disable } = useInstallerPush(token);
  if (!supported) return null;

  return (
    <div className="inst-push" dir="rtl">
      {iosBlocked ? (
        <span className="inst-push-hint">
          برای دریافتِ اعلانِ کار روی iOS، ابتدا برنامه را از منوی Share با «Add to Home Screen» نصب کنید.
        </span>
      ) : permission === 'denied' ? (
        <span className="inst-push-hint">
          اعلان‌ها در مرورگر مسدود شده‌اند. برای دریافتِ پیشنهادِ کار حتی با برنامهٔ بسته، از تنظیماتِ سایت اجازه دهید.
        </span>
      ) : subscribed ? (
        <button type="button" className="inst-push-btn is-on" onClick={disable} disabled={busy} title="غیرفعال‌سازی اعلانِ کار">
          <BellIcon />
          {busy ? 'در حال تغییر...' : 'اعلانِ کار فعال است'}
        </button>
      ) : (
        <button type="button" className="inst-push-btn" onClick={enable} disabled={busy} title="پیشنهادِ کار حتی با برنامهٔ بسته به شما برسد">
          <BellIcon />
          {busy ? 'در حال فعال‌سازی...' : 'فعال‌سازی اعلانِ کار'}
        </button>
      )}
      {error && <span className="inst-push-error" role="alert">{error}</span>}
    </div>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}
